module.exports = __webpack_public_path__ + "static/media/lupa.1ed44e9e.svg";